import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ToastrService} from 'ngx-toastr';

const BASE_URL = 'api/';


@Injectable()

export class MainService {

	constructor(private http: HttpClient,
				private toast: ToastrService) {
	}

	// http get methode
	httpGet(url: string): Observable<any> {
		//return this.http.get<any>(BASE_URL + url)
		return this.http.get<any>(BASE_URL + url).pipe(
			catchError(this.handleError<any>('get : ' + url))
		);
	}


	// http post methode
	httpPost(url: string, params: any): Observable<any> {
		return this.http.post<any>(BASE_URL + url, params).pipe(
			catchError(this.handleError<any>('post : ' + url))
		);
	}

	// http patch methode
	httpPatch(url: string, params: any): Observable<any> {
		return this.http.patch<any>(BASE_URL + url, params).pipe(
			catchError(this.handleError<any>('ptach : ' + url))
		);
	}


	// http delete methode
	httpDelete(url: string): Observable<any> {
		return this.http.delete<any>(BASE_URL + url).pipe(
			catchError(this.handleError<any>('delete : ' + url))
		);
	}

	// Errors
	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {

			//this.toast.error(error.message, error.status + ' : ' + error.statusText);
			return Observable.throw(error);
			//return of(result as T);
		};
	}
}
